import { useEffect, useRef, useState } from "react";
import { MoreVertical } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ProductRowMenu = ({ productId }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOutside = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50"
        aria-label="Open product actions"
      >
        <MoreVertical size={18} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 bg-white border rounded-lg shadow-md w-44 z-50 overflow-hidden">
          <button
            onClick={() => {
              navigate(`/admin/products/${productId}/edit`);
              setOpen(false);
            }}
            className="block w-full text-left px-4 py-2.5 hover:bg-amber-50 text-sm"
          >
            Edit Product
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductRowMenu;
